export function resetNativeFileInput(input: HTMLInputElement): void {
  input.value = "";
}

export function setNativeFileInputFiles(input: HTMLInputElement, files: File[]): void {
  if (!files.length) {
    resetNativeFileInput(input);
    return;
  }

  if (nativeFileInputFilesMatch(input, files)) return;

  if (typeof DataTransfer === "undefined") {
    resetNativeFileInput(input);
    return;
  }

  try {
    const dataTransfer = new DataTransfer();
    files.forEach(file => dataTransfer.items.add(file));
    input.files = dataTransfer.files;
  } catch {
    resetNativeFileInput(input);
  }
}

export function nativeFileInputFilesMatch(input: HTMLInputElement, files: File[]): boolean {
  const inputFiles = Array.from(input.files ?? []);

  return inputFiles.length === files.length && inputFiles.every((file, index) => file === files[index]);
}
